export default __webpack_public_path__ + "static/media/andy-warhol.e280b52b.jpg";